<div
  class="pt-4 pb-2 mt-6 w-full min-h-full bg-gray-300 border-t border-gray-400 md:pb-6 md:w-64 md:py-6 md:ml-0 md:mt-0 md:border-t-0 md:border-b-0 xl:w-92 xl:ml-4"
>
  <ng-container *ngIf="paymentSummary">
    <div class="mb-3 ml-4 text-lg font-bold text-gray-900 md:mb-4 md:text-2xl">Podsumowanie</div>

    <div class="flex flex-col mb-2 text-base md:text-xs">
      <div class="flex flex-row mx-4">
        <div class="flex-shrink-0 w-24 text-gray-700">Odbiorca:</div>
        <div class="flex min-w-0 leading-tighter break-with-hypen">
          <span>{{ paymentSummary.biller }}</span>
        </div>
      </div>

      <ng-container *ngIf="paymentSummary.paymentType === PaymentTypeEnum.LIABILITY; else balanceInfo">
        <div class="flex flex-row mx-4 mt-2 mb-2">
          <div class="flex-shrink-0 w-24 text-gray-700">Tytuł:</div>
          <div class="leading-tighter break-with-hypen">{{ paymentSummary.title }}</div>
        </div>
      </ng-container>

      <ng-template #balanceInfo>
        <app-balance-info [balance]="paymentSummary.balance"></app-balance-info>
      </ng-template>
    </div>

    <div class="hidden px-4 py-4 bg-primary-100 md:block">
      <ng-container *ngIf="paymentSummary.commisionVisible">
        <div class="flex flex-row text-xs">
          <div class="w-24 text-primary-700">Kwota:</div>
          <div>
            <span class="text-primary-800">{{ paymentSummary.amount | currency: 'PLN':'symbol':'.2-2':'pl-PL' }}</span>
          </div>
        </div>
        <div class="flex flex-row text-xs">
          <div class="w-24 text-primary-700">Prowizja:</div>
          <span class="text-primary-800">{{
            paymentSummary.commission | currency: 'PLN':'symbol':'.2-2':'pl-PL'
          }}</span>
        </div>
      </ng-container>
      <div class="flex flex-row items-baseline font-bold text-primary-600">
        <div class="w-24 text-sm">Do zapłaty:</div>
        <div class="text-lg">{{ paymentSummary.totalAmount | currency: 'PLN':'symbol':'.2-2':'pl-PL' }}</div>
      </div>
    </div>

    <form
      id="personalDataForm"
      class="flex flex-col mx-4 mt-4"
      [formGroup]="personalDataForm"
      autocomplete="on"
      (submit)="submit()"
    >
      <div class="mb-4 space-y-1">
        <!--name input-->
        <div class="flex flex-col">
          <div
            [ngClass]="{
              'text-red-600 border-red-600 focus-within:border-red-600':
                (personalDataForm.name.touched && personalDataForm.name.errors) ||
                personalDataForm.name.errors?.pattern,
              'border-primary-400 focus-within:border-primary-600': personalDataForm.name.valid
            }"
            class="flex flex-row items-stretch px-4 h-12 text-sm placeholder-gray-700 text-gray-900 bg-white rounded-lg border border-gray-400 md:h-10 focus-within:border-black"
          >
            <input
              id="fname"
              name="fname"
              formControlName="name"
              autocomplete="given-name"
              placeholder="Imię"
              aria-label="Imię"
              type="text"
              class="flex-grow text-base focus:outline-none md:text-sm"
              [ngClass]="{
                'text-red-600':
                  (personalDataForm.name.touched && personalDataForm.name.errors) ||
                  personalDataForm.name.errors?.pattern
              }"
            />
            <mat-icon
              *ngIf="personalDataForm.name.valid"
              class="self-center ml-1 -mr-1 text-primary-600 icon-20 md:icon-16"
              >check_circle_outline
            </mat-icon>
          </div>
          <div
            *ngIf="personalDataForm.name.errors?.pattern"
            class="flex flex-row items-center mt-1 text-sm text-red-600 md:text-xxs"
          >
            <mat-icon class="mr-1 icon-16 md:icon-12">error_outline</mat-icon>
            Imię zawiera nieprawidłowe znaki.
          </div>
        </div>

        <!--surname input-->
        <div class="flex flex-col">
          <div
            class="flex flex-row items-stretch px-4 h-12 text-sm placeholder-gray-700 text-gray-900 bg-white rounded-lg border border-gray-400 md:h-10 focus-within:border-black"
            [ngClass]="{
              'text-red-600 border-red-600 focus-within:border-red-600':
                (personalDataForm.surname.touched && personalDataForm.surname.errors) ||
                personalDataForm.surname.errors?.pattern,
              'border-primary-400 focus-within:border-primary-600': personalDataForm.surname.valid
            }"
          >
            <input
              id="lname"
              name="lname"
              formControlName="surname"
              autocomplete="family-name"
              placeholder="Nazwisko"
              aria-label="Nazwisko"
              type="text"
              class="flex-grow text-base focus:outline-none md:text-sm"
              [ngClass]="{
                'text-red-600 border-red-600 focus:border-red-600':
                  (personalDataForm.surname.touched && personalDataForm.surname.errors) ||
                  personalDataForm.surname.errors?.pattern
              }"
            />
            <mat-icon
              *ngIf="personalDataForm.surname.valid"
              class="self-center ml-1 -mr-1 text-primary-600 icon-20 md:icon-16"
              >check_circle_outline
            </mat-icon>
          </div>
          <div
            *ngIf="personalDataForm.surname.errors?.pattern"
            class="flex flex-row items-center mt-1 text-sm text-red-600 md:text-xxs"
          >
            <mat-icon class="mr-1 icon-16 md:icon-12">error_outline</mat-icon>
            Nazwisko zawiera nieprawidłowe znaki.
          </div>
          <div
            *ngIf="
              (personalDataForm.surname.dirty || personalDataForm.surname.touched) &&
              personalDataForm.surname.errors?.required
            "
            class="flex flex-row items-center mt-1 text-sm text-red-600 md:text-xxs"
          >
            <mat-icon class="mr-1 icon-16 md:icon-12">error_outline</mat-icon>
            Wpisz nazwisko.
          </div>
        </div>

        <!--email input-->
        <div class="flex flex-col">
          <div
            class="flex flex-row items-stretch px-4 h-12 text-sm placeholder-gray-700 text-gray-900 bg-white rounded-lg border border-gray-400 md:h-10 focus-within:border-black"
            [ngClass]="{
              'text-red-600 border-red-600 focus-within:border-red-600':
                personalDataForm.email.touched && personalDataForm.email.errors,
              'border-primary-400 focus-within:border-primary-600': personalDataForm.email.valid
            }"
          >
            <input
              id="email"
              name="email"
              formControlName="email"
              autocomplete="email"
              placeholder="Adres e-mail"
              aria-label="Adres e-mail"
              type="email"
              class="flex-grow text-base focus:outline-none md:text-sm"
            />
            <mat-icon
              *ngIf="personalDataForm.email.valid"
              class="self-center ml-1 -mr-1 text-primary-600 icon-20 md:icon-16"
              >check_circle_outline
            </mat-icon>
          </div>
          <div
            class="flex flex-row items-center mt-1 text-sm text-red-600 md:text-xxs"
            *ngIf="personalDataForm.email.touched && personalDataForm.email.errors"
          >
            <mat-icon class="mr-1 icon-16 md:icon-12">error_outline</mat-icon>
            Wpisz poprawny adres e-mail.
          </div>
        </div>
      </div>

      <div *ngIf="imojeTosVisible" class="flex flex-col mb-3">
        <mat-checkbox [formControl]="imojeTosControl">
          <span
            [class]="
              (imojeTosControl.dirty || imojeTosControl.touched) && !imojeTosControl.value
                ? 'text-red-600'
                : 'text-gray:800'
            "
          >
            Oświadczam, że zapoznałem się i akceptuję
            <a
              class="text-gray-700 underline transition-colors duration-150 hover:text-gray-500"
              href="https://data.imoje.pl/docs/imoje_regulamin_platnosci.pdf"
              target="_blank"
              >Regulamin imoje</a
            >
            oraz
            <a
              class="text-gray-700 underline transition-colors duration-150 hover:text-gray-500"
              href="https://data.imoje.pl/docs/imoje_informacja_administratora_danych_osobowych.pdf"
              target="_blank"
              >Informację o danych osobowych imoje</a
            >. (Wymagane)
          </span>
        </mat-checkbox>
        <div
          *ngIf="(imojeTosControl.dirty || imojeTosControl.touched) && imojeTosControl.errors?.required"
          class="flex flex-row items-center mt-1 text-sm text-red-600 md:text-xxs"
        >
          <mat-icon class="mr-1 icon-16 md:icon-12">error_outline</mat-icon>
          Wyrażenie zgody jest wymagane.
        </div>
      </div>

      <div class="hidden flex-col md:flex">
        <app-submit-button [ready]="submitReady" [loading]="submitted">
          PŁACĘ {{ paymentSummary.totalAmount | currency: 'PLN':'symbol':'.2-2':'pl-PL' }}
        </app-submit-button>
        <span class="mt-1"></span>

        <div class="mt-3 text-sm text-gray-700 leading-tighter md:text-xxs">
          Kliknięcie w przycisk oznacza zapoznanie się się i akceptację
          <a
            class="underline transition-colors duration-150 hover:text-gray-500"
            target="_blank"
            [href]="brand.termsOfUseLink"
            >Regulaminu</a
          >
          oraz
          <a
            class="underline transition-colors duration-150 hover:text-gray-500"
            target="_blank"
            [href]="brand.privacyPolicyLink"
            >Polityki Prywatności</a
          >.
        </div>
      </div>
    </form>
  </ng-container>
</div>
